import { ActionMenu } from '@ijoin/components';
import { AnnuityCarrierTransactionRes } from '@ijoin/hooks';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { useToggle } from 'usehooks-ts';

import { MarkAsReversalDialog } from './MarkAsReversalDialog';

export const CarrierTransactionActionsCell = (props: {
  annuityIntegrationId: string;
  transaction: AnnuityCarrierTransactionRes;
}) => {
  const [isDialogOpen, toggleDialogOpen] = useToggle();

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Edit', onSelect: toggleDialogOpen }]}
        trigger={
          <IconButton
            data-component='actionsMenu'
            data-testid={`actions-carrierTransaction-${props.transaction.id}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      {isDialogOpen && (
        <MarkAsReversalDialog
          annuityIntegrationId={props.annuityIntegrationId}
          onClose={toggleDialogOpen}
          transaction={props.transaction}
        />
      )}
    </>
  );
};
